// extracted by mini-css-extract-plugin
export default {"period_button_block":"styled_period_button_block__ZNdv1","period_statistic_button":"styled_period_statistic_button__1mhXW","modal_close_button":"styled_modal_close_button__AM997"};